const customerC5Error = [
  "1",
  "5",
  "6",
  "10",
  "11",
  "13",
  "457",
  "458",
  "459",
  "460",
  "461",
  "462",
  "465",
  "466",
  "541",
];

const customerWPError = [
  "3",
  "4",
  "8",
  "42",
  "45",
  "46",
  "49",
  "50",
  "53",
  "62",
  "65",
];

// Helper function to check if value is in array
const isIN = (array, value) => {
  return array.includes(value);
};

// Implementation of IsCustomerError logic
export function isCustomerError(errorCode, ctrlType) {
  let out = false;
  errorCode = String(errorCode); // make it a string

  if (ctrlType === "C5" && isIN(customerC5Error, errorCode)) out = true;
  if (ctrlType === "C5E" && isIN(customerC5Error, errorCode)) out = true;
  if (ctrlType === "C5PLG" && isIN(customerC5Error, errorCode)) out = true;
  if (ctrlType === "C5EPLG" && isIN(customerC5Error, errorCode)) out = true;
  if (ctrlType === "WellPro II" && isIN(customerWPError, errorCode)) out = true;

  // console.log(
  //   "______________ isCustomerError = %s %s %s ",
  //   ctrlType,
  //   errorCode,
  //   out
  // );
  return out;
}
// export function getStateDescriptions(ctrlType, state, shutdownCode) {
//   const stateNum = Number(state);
//   const shutdownNum = Number(shutdownCode);

//   let stateDescr = "STANDBY";
//   let shutdownDescr = "SHUTDOWN";

//   if (ctrlType === "WellPro II") {
//     // --- STATE DESCRIPTIONS for WellPro II ---
//     switch (stateNum) {
//       case -1:
//         stateDescr = "MODBUS ERROR";
//         break;
//       case 0:
//         stateDescr = "POWERUP";
//         break;
//       case 1:
//         stateDescr = "READY_TO_START";
//         break;
//       case 2:
//         stateDescr = "UNLOAD";
//         break;
//       case 3:
//         stateDescr = "MOTORSTART";
//         break;
//       case 4:
//         stateDescr = "SPINDOWN";
//         break;
//       case 5:
//         stateDescr = "CRANK";
//         break;
//       case 6:
//         stateDescr = "CRANK_REST";
//         break;
//       case 7:
//         stateDescr = "WARMUP";
//         break;
//       case 8:
//         stateDescr = "WAITONEWT";
//         break;
//       case 9:
//         stateDescr = "RAMP_TO_RATED_RPM";
//         break;
//       case 10:
//         stateDescr = "LOADED";
//         break;
//       case 11:
//         stateDescr = "COOLDOWN";
//         break;
//       case 12:
//         stateDescr = "SHUTDOWN";
//         break;
//       case 13:
//         stateDescr = "WAIT_ON_EOT";
//         break;
//       case 14:
//         stateDescr = "WAIT_ON_EOTEWT";
//         break;
//       case 15:
//         stateDescr = "WAIT_ON_LOAD_RPM";
//         break;
//       default:
//         stateDescr = "STANDBY";
//     }

//     // --- SHUTDOWN DESCRIPTIONS for WellPro II ---
//     switch (shutdownNum) {
//       case -1:
//         shutdownDescr = "";
//         break;
//       case 0:
//         shutdownDescr = "Normal Operation";
//         break;
//       case 1:
//         shutdownDescr = "Low Engine Oil Level";
//         break;
//       case 2:
//         shutdownDescr = "Low Engine Jacket Water";
//         break;
//       case 3:
//         shutdownDescr = "High 1st Stage Scrubber Level";
//         break;
//       case 4:
//         shutdownDescr = "High 2nd Stage Scrubber Level";
//         break;
//       case 5:
//         shutdownDescr = "ROC Override Active";
//         break;
//       case 6:
//         shutdownDescr = "High Compressor Vibration";
//         break;
//       case 7:
//         shutdownDescr = "Spare DI07";
//         break;
//       case 8:
//         shutdownDescr = "Local Panel Emergency Stop";
//         break;
//       case 12:
//         shutdownDescr = "Failure To Crank";
//         break;
//       case 14:
//         shutdownDescr = "High Compressor Vibration";
//         break;
//       case 15:
//         shutdownDescr = "Lost Engine J1939 Comm";
//         break;
//       case 21:
//         shutdownDescr = "Lost Speed Signal/Engine Stall";
//         break;
//       case 38:
//         shutdownDescr = "LoLo System Voltage";
//         break;
//       case 41:
//         shutdownDescr = "HiHi System Voltage";
//         break;
//       case 42:
//         shutdownDescr = "LoLo Field Pressure";
//         break;
//       case 45:
//         shutdownDescr = "HiHi Field Pressure";
//         break;
//       case 46:
//         shutdownDescr = "LoLo Interstage Pressure";
//         break;
//       case 49:
//         shutdownDescr = "HiHi Interstage Pressure";
//         break;
//       case 50:
//         shutdownDescr = "LoLo Discharge Pressure";
//         break;
//       case 53:
//         shutdownDescr = "HiHi Discharge Pressure";
//         break;
//       case 58:
//         shutdownDescr = "LoLo Compressor Oil Pressure";
//         break;
//       case 61:
//         shutdownDescr = "HiHi Compressor Oil Pressure";
//         break;
//       case 62:
//         shutdownDescr = "LoLo Suction Scrubber Pressure";
//         break;
//       case 65:
//         shutdownDescr = "HiHi Suction Scrubber Pressure";
//         break;
//       case 78:
//         shutdownDescr = "HiHi Discharge Temperature";
//         break;
//       case 74:
//         shutdownDescr = "HiHi Temperature #2";
//         break;
//       default:
//         shutdownDescr = "SHUTDOWN";
//     }
//   } else {
//     // --- STATE DESCRIPTIONS for Other Controllers ---
//     switch (stateNum) {
//       case -1:
//         stateDescr = "MODBUS ERROR";
//         break;
//       case 0:
//         stateDescr = "STANDBY";
//         break;
//       case 25:
//         stateDescr = "UNLOAD_ST";
//         break;
//       case 50:
//         stateDescr = "START_DRIVER";
//         break;
//       case 60:
//         stateDescr = "WARMUP";
//         break;
//       case 65:
//         stateDescr = "RDY_TO_LOAD";
//         break;
//       case 70:
//         stateDescr = "WAIT_ON_COT_PERM";
//         break;
//       case 80:
//         stateDescr = "RAMP_TO_RATED";
//         break;
//       case 90:
//         stateDescr = "AT_LOAD";
//         break;
//       case 100:
//         stateDescr = "UNLOADING";
//         break;
//       case 110:
//         stateDescr = "COOLDOWN";
//         break;
//       case 120:
//         stateDescr = "STOP_DRIVER";
//         break;
//       case 130:
//         stateDescr = "SHUTDOWN";
//         break;
//       default:
//         stateDescr = "STANDBY";
//     }

//     // --- SHUTDOWN DESCRIPTIONS for Other Controllers ---
//     switch (shutdownNum) {
//       case -1:
//         shutdownDescr = "";
//         break;
//       case 0:
//         shutdownDescr = "Normal Operation";
//         break;
//       case 1:
//         shutdownDescr = "Local Emergency Stop";
//         break;
//       case 7:
//         shutdownDescr = "Lo Engine Oil Level";
//         break;
//       case 8:
//         shutdownDescr = "Lo Engine Jacket Water Level";
//         break;
//       case 10:
//         shutdownDescr = "Hi 1st Stage Scrubber Liquid Level";
//         break;
//       case 11:
//         shutdownDescr = "Hi 2nd Stage Scrubber Liquid Level";
//         break;
//       case 13:
//         shutdownDescr = "VFD PANEL SHUTDOWN";
//         break;
//       case 14:
//         shutdownDescr = "High Compressor Vibration";
//         break;
//       case 117:
//         shutdownDescr = "Engine Failure to Start";
//         break;
//       case 120:
//         shutdownDescr = "Engine Failure to Stop";
//         break;
//       case 123:
//         shutdownDescr = "Engine Stop Lamp";
//         break;
//       case 124:
//         shutdownDescr = "Lost J1939 Com";
//         break;
//       case 125:
//         shutdownDescr = "Lost RPM/Stall";
//         break;
//       case 257:
//         shutdownDescr = "Lo Compressor Oil Pressure";
//         break;
//       case 455:
//         shutdownDescr = "LoLo System Voltage";
//         break;
//       case 456:
//         shutdownDescr = "HiHi System Voltage";
//         break;
//       case 457:
//         shutdownDescr = "LoLo Field Pressure";
//         break;
//       case 458:
//         shutdownDescr = "HiHi Field Pressure";
//         break;
//       case 459:
//         shutdownDescr = "LoLo Interstage Pressure";
//         break;
//       case 460:
//         shutdownDescr = "HiHi Interstage Pressure";
//         break;
//       case 461:
//         shutdownDescr = "LoLo Discharge Pressure";
//         break;
//       case 462:
//         shutdownDescr = "HiHi Discharge Pressure";
//         break;
//       case 463:
//         shutdownDescr = "LoLo Main Flow Rate";
//         break;
//       case 464:
//         shutdownDescr = "HiHi Main Flow Rate";
//         break;
//       case 465:
//         shutdownDescr = "LoLo Suction Scrubber Pressure";
//         break;
//       case 466:
//         shutdownDescr = "HiHi Suction Scrubber Pressure";
//         break;
//       case 467:
//         shutdownDescr = "LoLo Compressor Oil Pressure";
//         break;
//       case 468:
//         shutdownDescr = "HiHi Compressor Oil Pressure";
//         break;
//       case 542:
//         shutdownDescr = "HiHi Discharge Temperature";
//         break;
//       case 543:
//         shutdownDescr = "LoLo Discharge #2 Temperature";
//         break;
//       case 544:
//         shutdownDescr = "HiHi Discharge #2 Temperature";
//       case 696:
//         shutdownDescr = "PLUNGER 3 Shutdown Active";
//         break;
//       default:
//         shutdownDescr = "SHUTDOWN";
//     }
//   }

//   return { stateDescr, shutdownDescr };
// }


export function getStateDescriptions(ctrlType, state, shutdownCode, sdsData = null) {
  // console.log(sdsData)

  const stateNum = Number(state);
  const shutdownNum = Number(shutdownCode);

  let stateDescr = "STANDBY";
  let shutdownDescr = "SHUTDOWN";


  if (shutdownNum === 0 && stateNum !== 12 && stateNum !== 130) {
    shutdownDescr = "Normal Operation";
  }
  // Use SDS data for other shutdown descriptions
  else if (sdsData && Array.isArray(sdsData) && sdsData.length > 0) {

    // "WellPro II" maps to "WP", other controllers map to "C5"
    const apiControllerType = ctrlType === "WellPro II" ? "WP" : "C5";
    // console.log(sdsData)

    const shutdownMatch = sdsData.find(
      item => item.controller === apiControllerType &&
        Number(item.sd) === shutdownNum
    );
    shutdownDescr = shutdownMatch
    ? shutdownMatch.description          // ← matched from API
    : `Unknown SD`;     // ← in sdsData but no match
  }
  else {
    shutdownDescr = `SD: ${shutdownNum}`; // ← sdsData not loaded yet
  }
  // Handle state descriptions (using hardcoded data since API doesn't have state info)
  if (ctrlType === "WellPro II") {
    // --- STATE DESCRIPTIONS for WellPro II ---
    switch (stateNum) {
      case -1:
        stateDescr = "MODBUS ERROR";
        break;
      case 0:
        stateDescr = "POWERUP";
        break;
      case 1:
        stateDescr = "READY_TO_START";
        break;
      case 2:
        stateDescr = "UNLOAD";
        break;
      case 3:
        stateDescr = "MOTORSTART";
        break;
      case 4:
        stateDescr = "SPINDOWN";
        break;
      case 5:
        stateDescr = "CRANK";
        break;
      case 6:
        stateDescr = "CRANK_REST";
        break;
      case 7:
        stateDescr = "WARMUP";
        break;
      case 8:
        stateDescr = "WAITONEWT";
        break;
      case 9:
        stateDescr = "RAMP_TO_RATED_RPM";
        break;
      case 10:
        stateDescr = "LOADED";
        break;
      case 11:
        stateDescr = "COOLDOWN";
        break;
      case 12:
        stateDescr = "SHUTDOWN";
        break;
      case 13:
        stateDescr = "WAIT_ON_EOT";
        break;
      case 14:
        stateDescr = "WAIT_ON_EOTEWT";
        break;
      case 15:
        stateDescr = "WAIT_ON_LOAD_RPM";
        break;
      default:
        stateDescr = "STANDBY";
    }
  } else {
    // --- STATE DESCRIPTIONS for Other Controllers (C5) ---
    switch (stateNum) {
      case -1:
        stateDescr = "MODBUS ERROR";
        break;
      case 0:
        stateDescr = "STANDBY";
        break;
      case 25:
        stateDescr = "UNLOAD_ST";
        break;
      case 50:
        stateDescr = "START_DRIVER";
        break;
      case 60:
        stateDescr = "WARMUP";
        break;
      case 65:
        stateDescr = "RDY_TO_LOAD";
        break;
      case 70:
        stateDescr = "WAIT_ON_COT_PERM";
        break;
      case 80:
        stateDescr = "RAMP_TO_RATED";
        break;
      case 90:
        stateDescr = "AT_LOAD";
        break;
      case 100:
        stateDescr = "UNLOADING";
        break;
      case 110:
        stateDescr = "COOLDOWN";
        break;
      case 120:
        stateDescr = "STOP_DRIVER";
        break;
      case 130:
        stateDescr = "SHUTDOWN";
        break;
      default:
        stateDescr = "STANDBY";
    }
  }

  return { stateDescr, shutdownDescr };
}